import React from "react";
import MemoryGame from "./components/MemoryGame";

function App() {
  return (
    <>
      <MemoryGame />
    </>
  );
}

export default App;
